export default "<button class=\"btn btn-primary\" (click)=\"downloadCsv()\">\n\t<ng-content></ng-content>\n</button>\n";